import React from "react";

const BuildingTrust = () => {
	return (
		<div className="max-w-[1200px] mx-auto flex -justify-center items-center  my-5">
			<div className="w-full flex md:flex-row flex-col-reverse justify-center items-center gap-5 mx-auto border border-gray-300  rounded-3xl blue p-10 sm:my-20">
				<div className="flex flex-col w-full  bg-gray justify-between">
					{/* Row  */}
					<div className="flex flex-col text-white">
						<h1 className=" text-3xl md:text-4xl font-bold text-white">
							Building on Trust
						</h1>
						<p className="sm:text-xl text-base my-6">
							We know that working together as a community is better for
							everyone. Our platform enables blockchain developers to build
							their dApps and wallets natively and connect with millions of
							users, without having to worry about the low-level implementation
							details.
						</p>
						{/* <div className="bg-white text-blue-600 sm:w-max w-full text-center px-6 font-semibold py-3 rounded-2xl">
							Check out our developers docs
						</div> */}
						<button
							className={`w-max flex justify-center items-center  relative serviceCardAnimation bg-white overflow-hidden rounded-full my-10 duration-500  blueText`}
						>
							<h5 className="w-full h-full  z-0 rounded-full"></h5>
							<h1
								className={`z-20 bg-transparent text-[0.9375rem] px-[2.5rem] py-[0.75rem] font-medium blueText`}
							>
								Check out our developers docs
							</h1>
						</button>
					</div>
				</div>

				<div className="flex items-center justify-center w-[380px] bg-gray">
					<div className="flex flex-col items-center justify-center">
						<img
							className="w-full h-full sm:w-[220px]"
							src="https://trustwallet.com/_next/static/media/raw.b373ab3f.svg"
							alt="Logo"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BuildingTrust;
